/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import PropTypes from 'prop-types';
export default function IconDots({ className }){
  return(
    <svg className={className} fill="none" height="16" viewBox="0 0 5 16" width="5" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.2832 4C3.26557 4 4.06932 3.1 4.06932 2C4.06932 0.9 3.26557 0 2.2832 0C1.30083 0 0.49707 0.9 0.49707 2C0.49707 3.1 1.30083 4 2.2832 4ZM2.2832 6C1.30083 6 0.49707 6.9 0.49707 8C0.49707 9.1 1.30083 10 2.2832 10C3.26557 10 4.06932 9.1 4.06932 8C4.06932 6.9 3.26557 6 2.2832 6ZM2.2832 12C1.30083 12 0.49707 12.9 0.49707 14C0.49707 15.1 1.30083 16 2.2832 16C3.26557 16 4.06932 15.1 4.06932 14C4.06932 12.9 3.26557 12 2.2832 12Z" fill="#323232"/>
    </svg>
  );
}
IconDots.propTypes = {
  className: PropTypes.string
};
